import type { GeoLocation } from '@smg-real-estate/geo-libs';

import {
  type AgentSearchFacets,
  isSameAgentSearchFacets,
} from '@/helpers/AgentDirectory/agentFacetRouteParams';
import { getLocationGeoId } from '@/stores/geoLocationHelpers';

const sortedGeoIds = (locations: GeoLocation[] | undefined): string[] =>
  (locations ?? [])
    .map((location) => getLocationGeoId(location) ?? '')
    .filter((id) => id.length > 0)
    .sort((a, b) => a.localeCompare(b));

export interface AgentSearchIdentity {
  resolvedLocations: GeoLocation[];
  currentPage: number;
  searchedLocations: GeoLocation[] | undefined;
  loadedPage: number;
  facets: AgentSearchFacets;
  searchedFacets: AgentSearchFacets;
}

/** True when resolved locations, page, and facets match the already-loaded agent search. */
export const isSameAgentSearch = ({
  resolvedLocations,
  currentPage,
  searchedLocations,
  loadedPage,
  facets,
  searchedFacets,
}: AgentSearchIdentity): boolean => {
  if (currentPage !== loadedPage) {
    return false;
  }

  if (!isSameAgentSearchFacets(facets, searchedFacets)) {
    return false;
  }

  const previousIds = sortedGeoIds(searchedLocations);
  const nextIds = sortedGeoIds(resolvedLocations);

  return (
    previousIds.length === nextIds.length && previousIds.every((id, index) => id === nextIds[index])
  );
};
